import styled from 'styled-components';

export const PartnerAdvantageMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        margin: 4rem 0 4rem 0;
        position:relative;

        @media(max-width:1023px){
            padding:1.5rem;
            margin:1.5rem 0 1.5rem 0;
        }
    `
);

export const PartnerAdvantageInnerWrap = styled.div(
    props => `
        max-width:1350px;
        margin:0 auto;
        display: flex;
        width:100%;
        justify-content: space-between;
        flex-direction: column;

        @media only screen and (min-width:1024px) and (max-width:1390px){
            padding: 2rem 2rem;
        }
    `
);

export const WhyPartnerHeadWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;

    `
);

export const WhyPartnerHeadText = styled.h2(
    props => `
        font-size:3.6rem;
        color: #2f281e;
        font-weight: 900;

        @media(max-width:1023px){
            font-size:2.4rem;
        }
    `
);

export const WhyPartnerSubText = styled.p(
    props => `
        font-size: 1.8rem;
        color: #333333;
        padding-top:0.5rem;

        @media(max-width:1023px){
            font-size: 1.4rem;
        }
    `
);

export const ImageBackOval = styled.div(
    props => `
        width:45%;
        height:65rem;
        background-color: #f2ecf3;
        position:absolute;
        top:0;
        right: 0;
        border-radius:40% 0 0 40%;

        @media(max-width:1023px){
            display: none;
        }
    `
);

export const PartnerAdvantageWrap =styled.div(
    props => `
        display: flex;
        width:100%;
        margin-top:3.5rem;
    `
);

export const AdvantageTileWrap = styled.div(
    props => `
        width:50%;
        display: flex;
        flex-direction: column;
    `
);

export const AdvantageTile = styled.div(
    props => `
        width:50rem;
        display: flex;
        align-items: center;
        padding:1.5rem;
        border-radius: 8px;
        box-shadow: 0 1px 1px 0 #c2c6eb;
        background-image: linear-gradient(263deg, #e8eaf8 1%, #feffff 99%);
        margin-bottom:1rem;
    `
);

export const TileIconWrap = styled.div(
    props => `
        width:4.2rem;
        height:4.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f0ecf4;
        border-radius: 50%;
    `
);

export const TileTextWrap = styled.div(
    props => `
        width:90%;
        display: flex;
        padding-left: 1.5rem;
    `
);

export const TileText = styled.p(
    props => `
        font-size: 2rem;
        color: #37474f;
        font-weight: bold;
    `
);

export const AdvantageImageWrap = styled.div(
    props => `
        width:50%;
        display: flex;
        z-index: 1;
    `
);

export const AdvantageImage = styled.img(
    props =>`
        width: 63rem;
        height:52.5rem;
        @media(max-width:1023px){
            width:100%;
            height: 100%;
        }
    `
);

export const MobileViewTag = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        @media(min-width:1024px){
            display: none;
        }
    `
)

export const AdvantageMobileImgWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        height: 300px;
        margin-top:3rem;
        margin-bottom:1.5rem;
    `
);

export const AdvantageTileWrapMobile = styled.div(
    props => `
        width:100%;
        display: flex;
        overflow:hidden;
    `
);

export const AdvantageTileMobileInner = styled.div(
    props => `
        width:100%;
        overflow: auto;
        display: -webkit-box
    `
);

export const MobileTileWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding:1.5rem;
        border-radius: 8px;
        box-shadow: 0 1px 1px 0 #c2c6eb;
        background-image: linear-gradient(263deg, #e8eaf8 1%, #feffff 99%);
        margin-right:1rem;
        margin-bottom:1rem;
        align-items: center;
    `
);

export const MobileTileIconWrap = styled.div(
    props => `
        width:4.2rem;
        height:4.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f0ecf4;
        border-radius: 50%;
    `
);

export const MobileTileTextWrap = styled.div(
    props => `
        width:90%;
        display: flex;
        padding-left: 1.5rem;
    `
);

export const MobileTileText = styled.p(
    props => `
        font-size: 1.4rem;
        font-weight: bold;
        color: #37474f;
    `
)